import useTelemetryStore from "@/store/telemetry";
import useStore from "@/store";
/* eslint-disable */ 

export const getCameraIndex = () => {
    console.log("getCameraIndex");
    const telemetryStore = useTelemetryStore();
    const store = useStore();
    const childDeviceSn = store.child_device_sn;
    console.log(childDeviceSn);
    if (childDeviceSn === null || childDeviceSn === undefined) {
        return null;
    }
    try {
        const cameras = telemetryStore.devices[childDeviceSn]["cameras"]["value"]
        if (cameras === null || cameras === undefined) {
            return null;
        }
        if (cameras.length === 0) {
            return null;
        }
        const camera = cameras[0];
        console.log(camera);
        return camera.payload_index;
    } catch (error) {
        console.log(error);
        return null;
    }
}